import React from 'react'
import Link from 'next/link'
import Slider from 'react-slick'
import { CarouselSettings } from '@/utils/carourselConfig'
import classNames from 'classnames'
import { format } from 'date-fns'

const LatestNews = ({ speakerData }) => (
  <>
    <div className="md:w-full lg:w-full border-t-[1px] border-custom-gray-80 w-full"></div>
    <section className="lg:py-24 md:py-14 py-11 md:mb-11 lg:mb-0">
      <div className="px-10 maxSm:px-6 slick-buttons-profile">
        <p className="mb-[16px] md:mb-16 text-[20px] md:text-2xl text-center text-white uppercase tagline-font">
          Latest News + Press
        </p>
        <Slider {...CarouselSettings}>
          {speakerData?.map((speaker) =>
            speaker?.articles?.map((slide, index) => (
              <div
                className="flex flex-col items-center w-full px-4 mx-auto text-center md:px-20 xl:w-1/2 lg:w-3/4"
                key={index}
              >
                {slide.url ? (
                  <Link href={slide.url} legacyBehavior>
                    <a target="_blank">
                      <p className="latest-news-headline text-[14px] leading-7 font-medium  md:text-2xl md:leading-[50px] lg:text-4xl lg:leading-[45px] md:font-normal text-white cursor-pointer hover:underline underline-offset-2 antialiased">
                        “{slide.headline}”
                      </p>
                    </a>
                  </Link>
                ) : (
                  <p className="latest-news-headline text-[14px]  font-medium md:text-2xl md:leading-[50px] lg:text-4xl lg:leading-[45px] md:font-normal text-white hover:underline underline-offset-2 antialiased">
                    “{slide.headline}”
                  </p>
                )}
                <div
                  className={classNames(
                    speaker.articles.length == 1
                      ? 'xs:mt-[14px] mb-6 md:mb-0'
                      : 'xs:mt-[14px] mb-6 md:mb-4'
                  )}
                >
                  <span
                    className={classNames(
                      slide.sourceName
                        ? 'text-sm latest-news-date lg:text-xl border-r-2 border-custom-gray-80'
                        : '',
                      'text-custom-gray-80 pr-4 font-normal '
                    )}
                  >
                    {slide.date && format(new Date(slide.date), 'MMMMMMM dd, yyyy')}
                  </span>
                  <span className="text-sm ml-4 latest-news-date lg:text-xl font-normal text-white">
                    {slide.sourceName}
                  </span>
                </div>
              </div>
            ))
          )}
        </Slider>
      </div>
    </section>
  </>
)

export default LatestNews
